<template>

    <nav-bar />

    <main-container>
        <list-group v-if="appNotifications.length > 0">
            <list-item  v-for="obj in appNotifications" :key="obj.id" v-on:click="$router.push(`/appNotifications/${obj.id}`)" >                                      
                <template v-slot:title>
                    <h5 class="mb-1 gray" v-if="obj.viewingDate">{{ obj.title }}</h5>                    
                    <h5 class="mb-1 fw-bold" v-else>{{ obj.title }}</h5>                    
                </template>
                <template v-slot:complement>                                                
                    <small class="mb-0">{{ formatFullDate(obj.createdAt) }}</small>                                        
                </template>

            </list-item> 
                                    
        </list-group>

        <list-group v-else>
          <list-item>
            <template v-slot:title>
                <h5 class="mb-1 fw-bold">Nenhuma Notificação Pendente!</h5> 
            </template>                            
          </list-item>                         
        </list-group>          
    </main-container>

    <bottom-bar />

</template>

<script>

import { getInstance } from "../../api/api";
import { showErrorModal } from "../../services/popups";
import {formatFullDate} from "../../services/formatters";
import { useUserStore } from '../../store/user';
const api = getInstance();

export default {
    name:"AppNotificationsListView",
    inject:["mySpinner"],   
    setup() {
        const userStore = useUserStore();

        return { userStore }
    },    
    async mounted() {
        await this.getAppNotificationsByTargetId();
    },
    data() {
        return {
            appNotifications:[]
        }
    },
    methods: {
        async getAppNotificationsByTargetId() {

            this.mySpinner.loading = true;

            try {

                let response = await api.get("v1/AppNotifications", {params: {userId:this.userStore.getUser.id}});

                this.mySpinner.loading = false;

                if (!response.data.success) {
                    showErrorModal(response.data.message);
                }
                else {                    
                    this.appNotifications = response.data.data;
                }

            } catch {
                this.mySpinner.loading = false;                
            }            
        },
        formatFullDate
    }
}
</script>


<style lang="css" scoped>
    @import"../../assets/css/_appnotifications";
</style>
